import React, { useContext, useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import APICaller from "../../../utils/APICaller";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { message } from "antd";
import { signoutThunk, userUpdateThunk } from "../../../store/thunks/authThunk";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearRedux } from "../../../store/slices/authSlice";
import media from "../../../media";

const UserProfile = (props) => {
  const dispatch = useDispatch();
  const { slsToken, slsLIUId, slsRole } = props;
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const logoutSuccessUrl = secureLocalStorage.getItem("logoutSuccessUrl");
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );
  const userProfileImage = useSelector((state) => state.auth.profileImage);
  const userName = useSelector((state) => state.auth.lIU);
  const userEmpID = useSelector((state) => state.auth.empID);
  
  const navigateSignIn = () => {
    window.location.href = process.env.REACT_APP_SSO_LOGIN_REDIRECT_URI;
  };
  const handleSignOut = async () => {
    console.log("Signout payload:", {
      role: storeRole,
      lIUId: storeLIUId,
      token: storeToken,
      accessTokenExpiresOn: storeAccessTokenExpiresOn,
    });
    try {
      await dispatch(
        signoutThunk({
          role: storeRole,
          lIUId: storeLIUId,
          token: storeToken,
          accessTokenExpiresOn: storeAccessTokenExpiresOn,
        })
      ).unwrap();      
    } catch (error) {
      console.error("Error during sign out:", error);
    } finally {
      dispatch(clearRedux(storeLIUId));
      window.location.href =
        process.env.REACT_APP_SSO_LOGIN_REDIRECT_URI;
    }
  };

  useEffect(() => {
    const handleOutside = (e) => {
      if (!e.target.closest(".account-menu-wrapper")) {
        setShowAccountMenu(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);
  return (
    <div className="account-menu-wrapper">
      <button
        className="account-btn"
        onClick={() => setShowAccountMenu(!showAccountMenu)}
      >
        <img
              src={
                userProfileImage ? process.env.REACT_APP_BACKEND + "/images/" + userProfileImage : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
              }
              alt={`${userName} (EmpID - ${userEmpID})`}
              className="profile-img"
            /><span className="namelinkclass">{userName}</span>
        <i
          className={`fa fa-angle-${showAccountMenu ? "up" : "down"} dropdown`}
        ></i>
      </button>

      {showAccountMenu && (
        <div className="account-dropdown">
          {slsToken && <button onClick={handleSignOut}>Logout</button>}
        </div>
      )}
    </div>
  );
};

export default UserProfile;
